var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","color":"bgHeaderFooter"}},[_vm._v(" MASEC 2021 "),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }